module.exports = __webpack_public_path__ + "img/level-balloon.fb5e405.png";